import { useState, useRef, useEffect } from "react";
import { PatternFormat } from "react-number-format";
import useAuthStore from "../../../../../stores/auth"; // Add this import

import {
  Box,
  Drawer,
  Stack,
  Divider,
  Typography,
  IconButton,
  Button,
  Chip,
  CircularProgress,
  TextField,
  Autocomplete,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import CloudDoneIcon from "@mui/icons-material/CloudDone";

import useHrmEmployeeStore from "../../../../../stores/hrEmployee";
import { handleKeyPress } from "../../../../../utils/inputValidation";
import { fetchDominioData } from "../../../../../fetchDominioData";
const grau_de_instrucao = [
  { label: "Analfabeto", value: 1 },
  { label: "Mestrado", value: 10 },
  { label: "Doutorado", value: 11 },
  { label: "PhD", value: 12 },
  { label: "Pós Graduação", value: 13 },
  { label: "Primário incompleto", value: 2 },
  { label: "Primário completo", value: 3 },
  { label: "Ginásio incompleto", value: 4 },
  { label: "Ginásio completo", value: 5 },
  { label: "2o Grau incompleto", value: 6 },
  { label: "2o Grau completo", value: 7 },
  { label: "Superior incompleto", value: 8 },
  { label: "Superior completo", value: 9 },
];

const raca_cor = [
  { label: "Indigena", value: 0 },
  { label: "Branca", value: 2 },
  { label: "Preta", value: 4 },
  { label: "Amarela", value: 6 },
  { label: "Parda", value: 8 },
];

const estado_civil = [
  { label: "Solteiro", value: "S" },
  { label: "Casado", value: "C" },
  { label: "Viúvo", value: "V" },
  { label: "Divorciado", value: "D" },
  { label: "Concubinato", value: "O" },
  { label: "Separado judicialmente", value: "J" },
  { label: "União estável", value: "U" },
];

const HRManagementEmployeePersonal = () => {
  const [state, setState] = useState(false);
  const [municipios, setMunicipios] = useState<
    { codigo_municipio: string; nome_municipio: string; codigo_uf: string }[]
  >([]);
  const [municipiosLoading, setMunicipiosLoading] = useState(false);
  const [paises, setPaises] = useState<
    { codigo_pais: string; nome_pais: string }[]
  >([]);
  const [paisesLoading, setPaisesLoading] = useState(false);
  const [ufs, setUfs] = useState<
    { codigo_uf: string; sigla_uf: string; nome_uf: string }[]
  >([]);
  const [ufsLoading, setUfsLoading] = useState(false);
  const openRef = useRef(null);
  const saveDraft = useHrmEmployeeStore((state: any) => state.saveDraft);
  const changeDraft = useHrmEmployeeStore((state: any) => state.changeDraft);
  const addDrawersRef = useHrmEmployeeStore(
    (state: any) => state.addDrawersRef,
  );
  const isSaving = useHrmEmployeeStore((state: any) => state.isSaving);
  const data = useHrmEmployeeStore((state: any) => state.data);
  const company = useAuthStore((state) => state.company);

  const getMunicipiosData = async () => {
    setMunicipiosLoading(true);
    try {
      const response = await fetchDominioData(
        `/empresa/${company.reference}/municipios`,
        {
          method: "GET",
        },
      );
      if (response) {
        setMunicipios(response.rows);
      }
    } catch (error) {
      console.error(error);
    }
    setMunicipiosLoading(false);
  };

  const getPaisesData = async () => {
    setPaisesLoading(true);
    try {
      const response = await fetchDominioData(
        `/empresa/${company.reference}/paises`,
        {
          method: "GET",
        },
      );
      if (response) {
        setPaises(response.rows);
      }
    } catch (error) {
      console.error(error);
    }
    setPaisesLoading(false);
  };

  const getUfsData = async () => {
    setUfsLoading(true);
    try {
      const response = await fetchDominioData(
        `/empresa/${company.reference}/uf`,
        {
          method: "GET",
        },
      );
      if (response) {
        setUfs(response.rows);
      }
    } catch (error) {
      console.error(error);
    }
    setUfsLoading(false);
  };

  useEffect(() => addDrawersRef({ name: "personal", ref: openRef }), []);

  useEffect(() => {
    if (state) {
      getMunicipiosData();
      getPaisesData();
      getUfsData();
    }
  }, [state]);

  return (
    <>
      <Button
        fullWidth
        ref={openRef}
        variant="outlined"
        onClick={() => {
          setState(true);
        }}
        disabled={data?.status === "editing" ? false : true}
      >
        <Stack spacing={1} alignItems="center">
          <PersonIcon fontSize="large" />
          <div>Pessoal</div>
        </Stack>
      </Button>
      <Drawer
        anchor="left"
        open={state}
        onClose={() => {
          setState(false);
        }}
      >
        <Box sx={{ p: 3, pt: 2, width: 400 }} width={300} height="100%">
          <Stack height="100%" spacing={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ flex: 1 }}
                alignItems="center"
              >
                <Typography variant="body1">Pessoal</Typography>
                {data.status === "editing" && (
                  <Chip
                    color="success"
                    variant="outlined"
                    icon={
                      isSaving === true ? (
                        <CircularProgress color="warning" size={18} />
                      ) : (
                        <CloudDoneIcon fontSize="small" />
                      )
                    }
                    label={isSaving ? "Salvando..." : "Tudo Salvo"}
                  />
                )}
              </Stack>
              <IconButton
                onClick={() => {
                  setState(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
            <Divider sx={{ my: 2 }} />
            <PatternFormat
              format="##/##/####"
              name="data_de_nascimento"
              fullWidth
              variant="filled"
              label="Data de Nascimento"
              defaultValue={data.draft?.data_de_nascimento || null}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              customInput={TextField}
              sx={{ mb: 1 }}
              required
            />
            <TextField
              name="grau_de_instrucao"
              fullWidth
              variant="filled"
              select
              size="small"
              label="Grau de Instrução"
              defaultValue={data.draft?.grau_de_instrucao || null}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              {grau_de_instrucao.map(({ label, value }) => (
                <option value={value} key={`grau_de_instrucao_${value}`}>
                  {label}
                </option>
              ))}
            </TextField>
            <TextField
              name="genero"
              fullWidth
              variant="filled"
              select
              size="small"
              label="Gênero"
              defaultValue={data.draft?.genero || null}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </TextField>
            <Autocomplete
              options={paises}
              getOptionLabel={(option) => option.nome_pais}
              loading={paisesLoading}
              value={
                paises.find(
                  (p) =>
                    String(p.codigo_pais) ===
                    String(data.draft?.codigo_pais_nacionalidade),
                ) || null
              }
              filterOptions={(options, { inputValue }) => {
                const searchTerm = inputValue.toLowerCase();
                return options.filter((option) =>
                  option.nome_pais.toLowerCase().includes(searchTerm),
                );
              }}
              isOptionEqualToValue={(option, value) =>
                option.codigo_pais === value.codigo_pais
              }
              renderOption={(props, option) => (
                <li
                  {...props}
                  key={`${option.codigo_pais}-${option.nome_pais}`}
                >
                  {option.nome_pais}
                </li>
              )}
              onChange={(event, newValue) => {
                changeDraft({
                  target: {
                    name: "codigo_pais_nacionalidade",
                    value: newValue?.codigo_pais ?? "",
                  },
                });
                changeDraft({
                  target: {
                    name: "codigo_pais_nascimento",
                    value: newValue?.codigo_pais ?? "",
                  },
                });
                saveDraft();
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="codigo_pais_nacionalidade"
                  label="País de nacionalidade"
                  variant="filled"
                  required
                  sx={{ mb: 1 }}
                  onBlur={() => saveDraft()}
                  onChange={changeDraft}
                />
              )}
            />
            <Autocomplete
              options={municipios}
              getOptionLabel={(option) => option.nome_municipio}
              loading={municipiosLoading}
              value={
                municipios.find(
                  (m) => m.nome_municipio === data.draft?.municipionascimento,
                ) || null
              }
              filterOptions={(options, { inputValue }) => {
                const searchTerm = inputValue.toLowerCase();
                return options.filter((option) =>
                  option.nome_municipio.toLowerCase().includes(searchTerm),
                );
              }}
              isOptionEqualToValue={(option, value) =>
                option.codigo_municipio === value.codigo_municipio
              }
              renderOption={(props, option) => (
                <li
                  {...props}
                  key={`${option.codigo_municipio}-${option.nome_municipio}`}
                >
                  {option.nome_municipio}
                </li>
              )}
              onChange={(event, newValue) => {
                if (newValue) {
                  changeDraft({
                    target: {
                      name: "municipionascimento",
                      value: newValue.nome_municipio,
                    },
                  });

                  changeDraft({
                    target: {
                      name: "codigo_municipionascimento",
                      value: newValue.codigo_municipio,
                    },
                  });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="municipionascimento"
                  label="Município de Nascimento"
                  variant="filled"
                  required
                  sx={{ mb: 1 }}
                  onBlur={() => saveDraft()}
                  onChange={changeDraft}
                />
              )}
            />
            <Autocomplete
              options={ufs}
              getOptionLabel={(option) => option.sigla_uf}
              loading={ufsLoading}
              value={
                ufs.find((u) => u.sigla_uf === data.draft?.estadonascimento) ||
                null
              }
              filterOptions={(options, { inputValue }) => {
                const searchTerm = inputValue.toLowerCase();
                return options.filter(
                  (option) =>
                    option.sigla_uf.toLowerCase().includes(searchTerm) ||
                    option.nome_uf.toLowerCase().includes(searchTerm),
                );
              }}
              isOptionEqualToValue={(option, value) =>
                option.codigo_uf === value.codigo_uf
              }
              renderOption={(props, option) => (
                <li {...props} key={`${option.codigo_uf}-${option.sigla_uf}`}>
                  {option.sigla_uf} - {option.nome_uf}
                </li>
              )}
              onChange={(event, newValue) => {
                if (newValue) {
                  changeDraft({
                    target: {
                      name: "estadonascimento",
                      value: newValue.sigla_uf,
                    },
                  });
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="estadonascimento"
                  label="Estado de Nascimento (UF)"
                  variant="filled"
                  required
                  sx={{ mb: 1 }}
                  onBlur={() => saveDraft()}
                  onChange={changeDraft}
                />
              )}
            />
            <TextField
              name="raca_cor"
              fullWidth
              variant="filled"
              select
              size="small"
              label="Raça/Cor"
              defaultValue={data.draft?.raca_cor || null}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              {raca_cor.map(({ label, value }) => (
                <option value={value} key={`raca_cor_${value}`}>
                  {label}
                </option>
              ))}
            </TextField>

            <TextField
              name="estado_civil"
              fullWidth
              variant="filled"
              select
              size="small"
              label="Estado Civil"
              defaultValue={data.draft?.estado_civil || null}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              {estado_civil.map(({ label, value }) => (
                <option value={value} key={`estado_civil_${value}`}>
                  {label}
                </option>
              ))}
            </TextField>
            <TextField
              name="nome_mae"
              fullWidth
              variant="filled"
              label="Nome da Mãe"
              defaultValue={data.draft?.nome_mae || null}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
              onKeyPress={handleKeyPress}
            />
            <TextField
              name="nome_pai"
              fullWidth
              variant="filled"
              label="Nome do Pai"
              defaultValue={data.draft?.nome_pai || null}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              onKeyPress={handleKeyPress}
            />
            <TextField
              name="deficiente_fisico"
              fullWidth
              variant="filled"
              select
              label="Possui Deficiência Física?"
              defaultValue={data.draft?.deficiente_fisico ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              <option value="0">Não</option>
              <option value="1">Sim</option>
            </TextField>
            <TextField
              name="recebia_seguro_desemprego"
              fullWidth
              variant="filled"
              select
              label="Recebia seguro desemprego?"
              defaultValue={data.draft?.recebia_seguro_desemprego ?? ""}
              SelectProps={{ native: true }}
              onBlur={() => saveDraft()}
              onChange={changeDraft}
              sx={{ mb: 1 }}
              required
            >
              <option value=""></option>
              <option value="0">Não</option>
              <option value="1">Sim</option>
            </TextField>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default HRManagementEmployeePersonal;
